import { render, staticRenderFns } from "./CategoryEditModal.vue?vue&type=template&id=4ad7f568&scoped=true"
import script from "./CategoryEditModal.vue?vue&type=script&lang=js"
export * from "./CategoryEditModal.vue?vue&type=script&lang=js"
import style0 from "./CategoryEditModal.vue?vue&type=style&index=0&id=4ad7f568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad7f568",
  null
  
)

export default component.exports